import * as Sentry from '@sentry/react';
import { Replay } from '@sentry/replay';

const initSentry = () => {
  const environment = process.env.REACT_APP_ENV || 'development';
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  const enabled = process.env.REACT_APP_SENTRY_ENABLED === 'true';

  // Only initialize Sentry if it's enabled and we have a DSN
  if (enabled && dsn) {
    Sentry.init({
      dsn,
      environment,
      enabled: environment !== 'development', // Disable in development
      tracesSampleRate: environment === 'production' ? 0.2 : 1.0,
      replaysOnErrorSampleRate: 1.0,
      replaysSessionSampleRate: environment === 'production' ? 0.1 : 1.0,
      integrations: [
        new Replay({
          maskAllText: true,
          blockAllMedia: true,
        }),
      ],
      beforeSend(event) {
        // Don't send events from localhost
        if (window.location.hostname === 'localhost') {
          return null;
        }
        return event;
      },
    });
  }
};

export default initSentry;
